<template>
  <div class="provision-generate app-main-content">
    <!-- 操作按钮 -->
    <el-card class="toolbar-card" shadow="never">
      <div class="toolbar-row">
        <div class="toolbar-left">
          <el-button
            v-show="$checkPermission(['role_generateProvision'])"
            type="primary"
            icon="el-icon-plus"
            :loading="actionLoading"
            @click="handleGenerate"
          >
            生成计提
          </el-button>
          <el-button icon="el-icon-check" :loading="actionLoading" @click="handleCalibrate">校准</el-button>
          <el-button icon="el-icon-close" :loading="actionLoading" @click="handleUnCalibrate">取消校准</el-button>
          <el-button icon="el-icon-s-promotion" :loading="actionLoading" @click="handlePublish">发布</el-button>
          <el-button icon="el-icon-download" :loading="actionLoading" @click="handleUnPublish">取消发布</el-button>
          <el-button icon="el-icon-refresh-left" :loading="actionLoading" @click="handleRecalculate">重新计算</el-button>
          <el-button type="danger" icon="el-icon-delete" :loading="actionLoading" @click="handleDelete">删除</el-button>
        </div>
      </div>
    </el-card>

    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form :model="queryParams" inline size="small">
        <el-form-item label="岗位">
          <el-select v-model="queryParams.stationName" placeholder="请选择" clearable style="width: 150px">
            <el-option v-for="s in stationOptions" :key="s.value" :label="s.label" :value="s.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="计提月份">
          <el-date-picker
            v-model="queryParams.provisionDateStart"
            type="month"
            placeholder="开始月份"
            value-format="yyyy-MM-dd"
            style="width: 130px"
          />
          <span style="margin: 0 5px">至</span>
          <el-date-picker
            v-model="queryParams.provisionDateEnd"
            type="month"
            placeholder="结束月份"
            value-format="yyyy-MM-dd"
            style="width: 130px"
          />
        </el-form-item>
        <el-form-item label="业务月份">
          <el-date-picker
            v-model="queryParams.businessDateStart"
            type="month"
            placeholder="开始月份"
            value-format="yyyy-MM-dd"
            style="width: 130px"
          />
          <span style="margin: 0 5px">至</span>
          <el-date-picker
            v-model="queryParams.businessDateEnd"
            type="month"
            placeholder="结束月份"
            value-format="yyyy-MM-dd"
            style="width: 130px"
          />
        </el-form-item>
        <el-form-item label="校准状态">
          <el-select v-model="queryParams.standardState" placeholder="请选择" clearable style="width: 120px">
            <el-option label="未校准" value="0" />
            <el-option label="已校准" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="发布状态">
          <el-select v-model="queryParams.publishState" placeholder="请选择" clearable style="width: 120px">
            <el-option label="未发布" value="0" />
            <el-option label="已发布" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card shadow="never">
      <cargo-ag-grid
        ref="agGrid"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%; height: 100%;"
        @selection-changed="onSelectionChanged"
      />

      <!-- 分页 -->
      <cargo-pagination
        class="pagination"
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>

    <!-- 生成计提弹窗 -->
    <generate-dialog
      :visible.sync="generateDialogVisible"
      @success="handleGenerateSuccess"
    />
  </div>
</template>

<script>
import { queryProvisionData, calibrate, unCalibrate, publish, unpublish, recalculate, deleteProvision } from '@/api/provision/provisionData'
import GenerateDialog from './components/GenerateDialog.vue'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'ProvisionGenerate',
  components: {
    GenerateDialog
  },
  data() {
    return {
      stationOptions: ProvisionConstants.ALL_GENERATE_STATIONS,
      // ========== 查询参数 ==========
      queryParams: {
        stationName: '',
        provisionDateStart: '',
        provisionDateEnd: '',
        businessDateStart: '',
        businessDateEnd: '',
        standardState: '',
        publishState: '',
        page: 1,
        pageSize: 100
      },

      // ========== 表格数据 ==========
      rowData: [],
      total: 0,

      // ========== 复选框选中数据 ==========
      selectedRows: [],

      // ========== 操作 loading（统一控制所有按钮，避免并发点击）==========
      actionLoading: false,

      // ========== 弹窗控制 ==========
      generateDialogVisible: false,

      // ========== AG Grid配置 ==========
      gridOptions: {
        // 启用多选模式
        rowSelection: 'multiple',
        // 禁止点击行选中
        suppressRowClickSelection: true
      },

      // ========== 表格列定义 ==========
      columnDefs: [
        // 复选框列配置（固定在左侧第一列）
        {
          headerCheckboxSelection: true, // 表头显示全选复选框
          checkboxSelection: true, // 每行显示复选框
          showDisabledCheckboxes: true, // 显示禁用状态的复选框
          width: 50, // 列宽
          pinned: 'left', // 固定在左侧
          suppressSizeToFit: true, // 禁止自动调整大小
          sortable: false, // 禁止排序
          resizable: false, // 禁止拖拽调整宽度
          suppressMovable: true // 禁止移动列位置
        },

        // 业务数据列
        { field: 'stationName', headerName: '岗位', width: 100 },
        {
          field: 'provisionDate',
          headerName: '计提月份',
          width: 120,
          valueFormatter: params => this.formatDate(params.value)
        },
        {
          field: 'businessDate',
          headerName: '业务月份',
          width: 120,
          valueFormatter: params => this.formatDate(params.value)
        },
        {
          field: 'ruleNames',
          headerName: '计提规则',
          width: 220,
          tooltipField: 'ruleNames',
          valueFormatter: params => params.value || '-'
        },
        {
          field: 'provisionAmount',
          headerName: '计提金额',
          width: 120,
          valueFormatter: params => this.formatAmount(params.value)
        },
        {
          field: 'updateAmount',
          headerName: '调整金额',
          width: 120,
          valueFormatter: params => this.formatAmount(params.value)
        },
        {
          field: 'standardState',
          headerName: '校准状态',
          width: 100,
          cellRenderer: params => {
            const state = params.value
            const text = state === '1' ? '已校准' : '未校准'
            const color = state === '1' ? '#67C23A' : '#909399'
            return `<span style="color: ${color}">${text}</span>`
          }
        },
        {
          field: 'publishState',
          headerName: '发布状态',
          width: 100,
          cellRenderer: params => {
            const state = params.value
            const text = state === '1' ? '已发布' : '未发布'
            const color = state === '1' ? '#67C23A' : '#E6A23C'
            return `<span style="color: ${color}">${text}</span>`
          }
        },
        {
          headerName: '对应人员',
          width: 120,
          cellRenderer: params => {
            return `<a href="javascript:void(0)" style="color: #409EFF; cursor: pointer;" onclick="window.viewPerson('${params.data.uuid}')">详情</a>`
          }
        }
      ]
    }
  },
  created() {
    // 暴露全局方法供ag-grid调用
    window.viewPerson = this.viewPerson
    this.getList()
  },
  beforeDestroy() {
    delete window.viewPerson
  },
  methods: {
    // ========== 数据查询方法 ==========

    /**
     * 获取列表数据
     */
    async getList() {
      const params = {
        stationName: this.queryParams.stationName || undefined,
        provisionDateStart: this.queryParams.provisionDateStart || undefined,
        provisionDateEnd: this.queryParams.provisionDateEnd || undefined,
        businessDateStart: this.queryParams.businessDateStart || undefined,
        businessDateEnd: this.queryParams.businessDateEnd || undefined,
        standardState: this.queryParams.standardState || undefined,
        publishState: this.queryParams.publishState || undefined,
        pageNum: this.queryParams.page,
        pageSize: this.queryParams.pageSize
      }

      const res = await queryProvisionData(params)
      if (res.ok && res.data) {
        this.rowData = res.data.list || []
        this.total = res.data.total || 0
      }
    },

    /**
     * 查询按钮点击事件
     */
    handleSearch() {
      this.queryParams.page = 1
      this.getList()
    },

    /**
     * 重置按钮点击事件
     */
    handleReset() {
      this.queryParams = {
        stationName: '',
        provisionDateStart: '',
        provisionDateEnd: '',
        businessDateStart: '',
        businessDateEnd: '',
        standardState: '',
        publishState: '',
        page: 1,
        pageSize: 100
      }
      this.getList()
    },

    // ========== 复选框相关方法 ==========

    /**
     * 复选框选择变化事件
     * @param {Object} event - AG Grid选择事件对象
     */
    onSelectionChanged(event) {
      // 获取当前选中的所有行数据
      this.selectedRows = event.api.getSelectedRows()
      console.log('选中的数据:', this.selectedRows)
    },

    // ========== 批量操作方法 ==========

    /**
     * 统一封装：选中校验 → 状态校验 → 二次确认 → 调接口 → 刷新列表
     * 所有操作按钮共用，自动处理 loading（禁用所有按钮）和异常。
     * @param {Object} opts
     * @param {Function} opts.stateCheck  返回 {ok, msg}，false 时中断
     * @param {String} opts.confirmText   二次确认弹窗文案，传空字符串则跳过确认
     * @param {Function} opts.api         接收 uuids 数组，返回 Promise
     * @param {String} opts.successMsg    成功提示
     */
    async runAction({ stateCheck, confirmText, api, successMsg }) {
      if (this.actionLoading) return
      if (!this.selectedRows.length) {
        this.$message.warning('请先选择记录')
        return
      }
      if (stateCheck) {
        const result = stateCheck(this.selectedRows)
        if (!result.ok) {
          this.$message.error(result.msg)
          return
        }
      }
      try {
        if (confirmText) {
          await this.$confirm(confirmText, '提示', { type: 'warning' })
        }
      } catch (e) {
        return // 用户取消
      }
      this.actionLoading = true
      try {
        const uuids = this.selectedRows.map(r => r.uuid)
        await api(uuids)
        this.$message.success(successMsg || '操作成功')
        this.getList()
      } catch (e) {
        console.error('操作失败', e)
      } finally {
        this.actionLoading = false
      }
    },

    /**
     * 生成计提（打开弹窗）
     */
    handleGenerate() {
      this.generateDialogVisible = true
    },

    /**
     * 生成计提成功回调
     */
    async handleGenerateSuccess(batchCount) {
      this.$message.success(batchCount > 1 ? `已成功生成 ${batchCount} 个月份的计提` : '生成成功')
      this.getList()
    },

    /**
     * 校准选中记录
     */
    handleCalibrate() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.standardState) === '1')
          return invalid.length
            ? { ok: false, msg: `${invalid[0].stationName}已校准，不能执行此操作` }
            : { ok: true }
        },
        confirmText: '确认校准选中的记录？',
        api: calibrate,
        successMsg: '校准成功'
      })
    },

    /**
     * 取消校准选中记录
     */
    handleUnCalibrate() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.standardState) === '0')
          return invalid.length
            ? { ok: false, msg: `${invalid[0].stationName}未校准，不能执行此操作` }
            : { ok: true }
        },
        confirmText: '确认取消校准选中的记录？',
        api: unCalibrate,
        successMsg: '取消校准成功'
      })
    },

    /**
     * 发布选中记录
     */
    handlePublish() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.publishState) === '1')
          return invalid.length
            ? { ok: false, msg: `${invalid[0].stationName}已发布，不能执行此操作` }
            : { ok: true }
        },
        confirmText: '确认发布选中的记录？',
        api: publish,
        successMsg: '发布成功'
      })
    },

    /**
     * 取消发布选中记录
     */
    handleUnPublish() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.publishState) === '0')
          return invalid.length
            ? { ok: false, msg: `${invalid[0].stationName}未发布，不能执行此操作` }
            : { ok: true }
        },
        confirmText: '确认取消发布选中的记录？',
        api: unpublish,
        successMsg: '取消发布成功'
      })
    },

    /**
     * 重新计算选中记录（耗时较长，loading 提示尤为重要）
     */
    handleRecalculate() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.publishState) === '1')
          return invalid.length
            ? { ok: false, msg: `${invalid[0].stationName}已发布，不能执行此操作` }
            : { ok: true }
        },
        confirmText: '确认重新计算选中的记录？校准状态将重置为未校准，请耐心等待。',
        api: recalculate,
        successMsg: '重新计算成功'
      })
    },

    // ========== 工具方法 ==========

    /**
     * 查看对应人员详情
     * @param {String} uuid - 数据UUID
     */
    /**
     * 查看对应人员详情 —— 跳转到「计提查询」页面，并通过 sessionStorage
     * 传递当前批次的查询条件，让目标页面自动按 provisionUuid 过滤。
     * （ProvisionQuery.vue 的 loadParamsAndQuery 会读取 provisionQueryParams）
     */
    viewPerson(uuid) {
      const row = this.rowData.find(item => item.uuid === uuid)
      const params = {
        uuid,
        stationName: row ? row.stationName : undefined,
        provisionDate: row ? row.provisionDate : undefined,
        businessDate: row ? row.businessDate : undefined
      }
      sessionStorage.setItem('provisionQueryParams', JSON.stringify(params))
      this.$router.push({ name: 'ProvisionQuery' })
    },

    handleDelete() {
      this.runAction({
        stateCheck: rows => {
          const invalid = rows.filter(r => String(r.standardState) === '1')
          return invalid.length
            ? { ok: false, msg: '已校准的记录不能删除' }
            : { ok: true }
        },
        confirmText: '确认删除选中的计提批次？删除后不可恢复。',
        api: deleteProvision,
        successMsg: '删除成功'
      })
    },

    /**
     * 格式化日期为年月格式（yyyy-MM）
     * @param {Date|String} date - 日期对象或字符串
     * @returns {String} 格式化后的日期字符串
     */
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },

    /**
     * 格式化金额为两位小数
     * @param {Number} amount - 金额
     * @returns {String} 格式化后的金额字符串
     */
    formatAmount(amount) {
      if (amount === null || amount === undefined) return ''
      return Number(amount).toFixed(2)
    }
  }
}
</script>

<style scoped lang="scss">
.provision-generate {
  padding: 10px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  overflow: hidden;

  .search-card {
    margin-bottom: 10px;
    flex-shrink: 0;
  }

  .toolbar-card {
    margin-bottom: 10px;
    flex-shrink: 0;
  }

  .toolbar-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .toolbar-left {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }

  .pagination {
    margin-top: 10px;
    text-align: right;
    flex-shrink: 0;
  }

  ::v-deep .el-card {
    flex-shrink: 0;
  }

  // 让数据表格卡片占据剩余空间
  > .el-card:nth-child(3) {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;

    ::v-deep .el-card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding-bottom: 10px;
      min-height: 400px;
    }
  }

  // AG Grid 空状态样式优化
  ::v-deep .ag-overlay-no-rows-wrapper {
    height: 100% !important;

    .ag-overlay-loading-center {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background: transparent;
      border: none;

      > div {
        padding: 50px 80px;
        background: #F5F7FA;
        border: 2px dashed #DCDFE6;
        border-radius: 8px;
        min-width: 300px;

        i {
          font-size: 16px;
          color: #909399;
          font-style: normal;
        }
      }
    }
  }
}
</style>
